var ARIA_EXPANDED = 'aria-expanded';
var ARIA_HIDDEN = 'aria-hidden';
var IS_OPENED_CLASS = 'is-opened';
var FACT_BOX = '[data-component="factBox"]';
var FACT_BOX_BODY = '[data-element="factBoxBody"]';
var factBoxes = Array.from(document.querySelectorAll(FACT_BOX));
factBoxes.forEach(function (factBox) {
  var btn = factBox.querySelector('[data-element="factBoxBtn"]');

  // Expanded fact boxes have no toggle button and are always shown.
  if (!btn) return;
  var showCollapsibleContent = function showCollapsibleContent(data) {
    data.btn.setAttribute(ARIA_EXPANDED, true);
    data.box.classList.add(IS_OPENED_CLASS);
    data.btnText.textContent = btn.dataset.less;
    data.body.setAttribute(ARIA_HIDDEN, false);
  };
  var hideCollapsibleContent = function hideCollapsibleContent(data) {
    data.btn.setAttribute(ARIA_EXPANDED, false);
    data.box.classList.remove(IS_OPENED_CLASS);
    data.btnText.textContent = btn.dataset.more;
    data.body.setAttribute(ARIA_HIDDEN, true);
  };
  var toggleCollapsibleContent = function toggleCollapsibleContent(btn) {
    var data = {
      btn: btn,
      btnText: btn.querySelector('[data-element="factBoxBtnText"]'),
      body: btn.closest(FACT_BOX).querySelector(FACT_BOX_BODY),
      box: btn.closest(FACT_BOX)
    };
    if (data.box.matches(".".concat(IS_OPENED_CLASS))) {
      hideCollapsibleContent(data);
    } else {
      showCollapsibleContent(data);
    }
  };
  btn.addEventListener('click', function () {
    return toggleCollapsibleContent(btn);
  });
});